import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Importing languages
import en from "../languages/en.json";
import de from "../languages/de.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: "de",
    lng: "de",
    resources: {
      // english language
      en: en,

      // German Language
      de: de,
    },
  });
